import * as React from 'react';
import classNames from 'clsx';
import Box from "../Box";
const SearchableSelectResult = props => {
  const {
    entry,
    highlighted,
    queryString,
    renderResult
  } = props;
  const className = classNames('SearchableList-item', {
    'SearchableList-item--highlighted': highlighted
  });
  return /*#__PURE__*/React.createElement(Box, {
    padding: 8,
    className: className
  }, renderResult({
    entry,
    highlighted,
    queryString
  }));
};
export default /*#__PURE__*/React.memo(SearchableSelectResult);